export default "__VITE_ASSET__krgII4BT__"